<template>
  <div class="bingli">
    <div class="bingli-title">
      <titleCard title="Cases Collection"></titleCard>
    </div>
    <div class="content">
      <div class="left animate__animated wow animate__fadeInLeft">
        <div class="txtbox">
          <h4>Organizer</h4>
          <p>
            the Capacity Building and Continuing Education Center of the NHC<br />Peking
            University People's Hospital
          </p>
        </div>
        <div class="txtbox">
          <h4>Supporting Organizer</h4>
          <p>
            China Research Hospital Association Blood Purification Committee
            <br />the Capacity Building and Continuing Education Center of the
            NHC, Society of Nephrology
          </p>
        </div>
        <div class="txtbox no">
          <h4>Host</h4>
          <p>GYT (Beijing) HealthCare Services Co., LTD</p>
        </div>
      </div>
      <div class="right animate__animated wow animate__fadeInRight"></div>
    </div>
    <div class="bg animate__animated wow animate__fadeIn">
      <div class="title">
        <div class="titleCard">
          <p>Background</p>
          <span></span>
        </div>
      </div>
      <p>
        Typical cases to be compiled into a book after the collection of cases,
        to help clinical medical exchanges and experience sharing in nephrology,
        to further promote the sharing of medical and healthcare resources,
        fully explore the nephrology education resources, know more about the
        current diagnosis and treatment situation, and promote the practice and
        application of evidence-based medicine in clinical work.
      </p>
    </div>
    <!-- 活动目标 -->
    <div class="mubiao">
      <div class="title">
        <titleCard title="Goals"></titleCard>
      </div>
      <div class="contentbox">
        <div
          class="box1 animate__animated wow animate__fadeInRight"
          data-wow-duration="0.8s"
        >
          <h2>01</h2>
          <p>
            Focus on "cases", typical cases are to be collected from
            nephrologists nationwide to broaden doctors' mind, improve their
            thinking ability and treatment consciousness, learn from others'
            experience and put it into practice.
          </p>
        </div>
        <div class="boxs">
          <div
            class="box2 animate__animated wow animate__fadeInRight"
            data-wow-duration="1.2s"
          >
            <h2>02</h2>
            <p style="font-size: 0.2226rem">
              Publicize typical clinical diagnosis and treatment cases in
              nephrology, and promote the standardization of clinical treatment
              in nephrology
            </p>
          </div>
          <div
            class="box3 animate__animated wow animate__fadeInRight"
            data-wow-duration="1.6s"
          >
            <h2>03</h2>
            <p>
              Seek evidence-based medical support for diagnosis and treatment
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动要求 -->
    <div class="zhengji">
      <div class="title">
        <titleCard title="Requirements"></titleCard>
      </div>
      <div class="zhengjibox">
        <div class="left animate__animated wow animate__fadeInLeft">
          <img src="../../assets/image/Science/bingli/bingli3.webp" alt="" />
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <h3>Cases Collection</h3>
          <p>
            Staff Requirements - Kidney-Related Departments<br />
            Title: Attending physician and above health professional technicians
          </p>
        </div>
      </div>
      <div class="zhengjibox">
        <div class="right right2 animate__animated wow animate__fadeInLeft">
          <h3>
            The contents of the case include but are not limited to the
            following:
          </h3>
          <p>
            primary glomerular disease, RPGN, thrombotic microangiopathy,
            secondary glomerular disease, hereditary or congenital kidney
            disease, renal tubular disease, interstitial nephritis,
            pregnancy-related kidney disease, acute kidney injury, typical cases
            of integrated treatment of CKD, typical cases of hemodialysis,
            peritoneal dialysis, and other uncategorized typical cases.
          </p>
        </div>
        <div class="left animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Science/bingli/bingli2.webp" alt="" />
        </div>
      </div>
      <div class="iosbox">
        <div class="left animate__animated wow animate__fadeInLeft">
          <img src="../../assets/image/Science/bingli/bingli3.webp" alt="" />
        </div>
        <div class="right animate__animated wow animate__fadeInRight">
          <h3>Cases Collection</h3>
          <p>
            Staff Requirements - Kidney-Related Departments<br />
            Title: Attending physician and above health professional technicians
          </p>
        </div>
      </div>
      <div class="iosbox">
        <div class="left animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/Science/bingli/bingli2.webp" alt="" />
        </div>
        <div class="right right2 animate__animated wow animate__fadeInLeft">
          <h3>
            The contents of the case include but are not limited to the
            following:
          </h3>
          <p>
            primary glomerular disease, RPGN, thrombotic microangiopathy,
            secondary glomerular disease, hereditary or congenital kidney
            disease, renal tubular disease, interstitial nephritis,
            pregnancy-related kidney disease, acute kidney injury, typical cases
            of integrated treatment of CKD, typical cases of hemodialysis,
            peritoneal dialysis, and other uncategorized typical cases.
          </p>
        </div>
      </div>
    </div>
    <!-- 项目优势 -->
    <div class="youshi animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="Advantages"></titleCard>
      </div>
      <div class="contbox">
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon1.webp" alt="" />
          <h3>Professional Team</h3>
          <p class="p1">strict review of each case</p>
          <p class="p2">strict review of each case</p>
        </div>
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon2.webp" alt="" />
          <h3>Wide Coverage</h3>
          <p class="p1">nationwide cases</p>
          <p class="p2">nationwide cases</p>
        </div>
        <div class="box">
          <img src="../../assets/image/Science/bingli/icon3.webp" alt="" />
          <h3>Business Value</h3>
          <p class="p1">nationwide cases help reinforce brand recognition</p>
          <p class="p2">nationwide cases help reinforce brand recognition</p>
        </div>
      </div>
      <p class="footertitle">
        After the evaluation of the expert group, the results of the
        solicitation will be published on the "China continuing medical
        education network" in September, and then the shortlisted cases will be
        collected into a book, typesetting and publishing
      </p>
      <div class="tougao animate__animated wow animate__pulse">
        <a
          href="https://mp.weixin.qq.com/s/rYtHdz0LaY0UqJuhVHhaVA"
          target="_blank"
          >Click to view details</a
        >
      </div>
    </div>
    <div class="footerCard">
      <h3>Project consultation</h3>
      <div class="span"></div>
      <p>
        <span><i class="el-icon-user-solid"></i> Contacts: Mr Hu</span> <a>|</a>
        <span><i class="el-icon-phone"></i>Contact number：177-7786-7690</span>
      </p>
      <p class="email">Email：snblzj@gytcare.com</p>
    </div>
  </div>
</template>

<script>
import titleCard from "../../components/title-card.vue";
// import footerCard from '../../components/footer-card.vue'

export default {
  data() {
    return {};
  },
  created() {},
  components: {
    titleCard,
    // footerCard
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.bingli {
  .bingli-title {
    padding: 1rem 0 1.5263rem 0;
  }
  .content {
    padding: 0 1.7895rem;
    height: 4.8632rem;
    display: flex;
    align-items: center;
    margin-bottom: 1.6421rem;
    @media screen and (max-width: 540px) {
      display: block;
      padding: 0 15px;
      height: 100%;
    }
    .left {
      flex: 1;
      .txtbox {
        margin-bottom: 0.6316rem;
        @media screen and (max-width: 540px) {
          margin-bottom: 27px;
        }
        h4 {
          color: #0ca6eb;
          font-size: 0.2947rem;
          margin: 0;
          margin-bottom: 0.2105rem;
          padding-left: 0.1263rem;
          border-left: 0.0737rem solid #0ca6eb;
          @media screen and (max-width: 540px) {
            font-size: 16px;
            border-left: 4px solid #0ca6eb;
          }
        }
        p {
          color: #333333;
          font-size: 0.2526rem;
          padding-left: 0.2rem;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
      }
      .no {
        margin-bottom: 0;
      }
    }
    .right {
      @media screen and (max-width: 540px) {
        height: 224px;
        width: 100%;
        margin-top: 40px;
        margin-left: 0;
      }
      width: 8.3684rem;
      height: 100%;
      margin-left: 1rem;
      background: url("../../assets/image/Science/bingli/bingli1.webp")
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .bg {
    height: 4.7368rem;
    width: 100%;
    background: url("../../assets/image/Science/bingli/bg1.webp") no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 300px;
      background-size: 150% 100%;
      background-position: 50% 0;
    }
    .title {
      padding: 0.7263rem 0 0.6316rem 0;
      @media screen and (max-width: 540px) {
        padding: 25px 0 40px 0;
      }
      .titleCard {
        text-align: center;
        p {
          padding-bottom: 0.3789rem;
          font-size: 0.4421rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.0526rem;
          @media screen and (max-width: 540px) {
            font-size: 21px;
            text-align: center;
          }
        }
        span {
          margin: 0 auto;
          position: relative;
          display: block;
          width: 3.0947rem;
          height: 0.0421rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 9.4737rem;
            height: 0.1263rem;
          }
        }
        span::after {
          content: "";
          position: absolute;
          left: 50%;
          margin-left: -0.2947rem;
          bottom: -0.0105rem;
          width: 0.5895rem;
          height: 0.0842rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 1.6842rem;
            height: 0.2211rem;
            margin-left: -0.8421rem;
          }
        }
      }
    }
    p {
      color: #ffffff;
      font-size: 0.2526rem;
      text-align: center;
      line-height: 0.4211rem;
      padding: 0 320px;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 20px;
        padding: 0 20px;
        text-align: left;
      }
    }
  }
  .mubiao {
    margin-bottom: 2.7368rem;
    .title {
      padding: 1.4316rem 0 0.9263rem 0;
    }
    .contentbox {
      margin: 0 1.7053rem;
      height: 5.6316rem;
      background: url("../../assets/image/Science/bingli/bg2.webp") no-repeat;
      background-size: 100% 100%;
      display: flex;
      // align-items: center;
      padding-top: 1.3263rem;
      box-sizing: border-box;
      @media screen and (max-width: 540px) {
        height: 100%;
        flex-wrap: wrap;
        margin: 0 15px;
        background: none;
      }
      h2 {
        margin: 0;
        padding-bottom: 0.4632rem;
        color: #0ca6eb;
        font-size: 0.8421rem;
        @media screen and (max-width: 540px) {
          font-size: 40px;
          padding-top: 25px;
        }
      }
      p {
        font-size: 0.2526rem;
        color: #666666;
        line-height: 0.4211rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          line-height: 22px;
          padding: 0 5px;
        }
      }
      .box1 {
        padding: 0 0.7579rem;
        width: 7.3684rem;
        margin-right: 0.2105rem;
        // box-sizing: border-box;
        @media screen and (max-width: 540px) {
          height: 267px;
          flex-basis: 100%;
          flex-shrink: 0;
          box-sizing: border-box;
          margin-bottom: 10px;
          background: url("../../assets/image/Science/bingli/bg2.webp")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      .boxs {
        display: flex;
        @media screen and (max-width: 540px) {
          background: url("../../assets/image/Science/bingli/bg2.webp")
            no-repeat;
          background-size: 100% 100%;
          height: 210px;
          width: 100%;
        }
        .box2 {
          width: 2.7789rem;
          padding: 0 0.4211rem;
          @media screen and (max-width: 540px) {
            width: 60%;
          }
        }
        .box3 {
          @media screen and (max-width: 540px) {
            width: 40%;
          }
          padding: 0 0.4211rem;
          width: 2.5263rem;
          margin-left: 0.1579rem;
        }
      }
    }
  }
  .zhengji {
    padding-bottom: 0.8842rem;
    .title {
      padding-bottom: 1.8526rem;
    }
    .iosbox {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      padding: 0 15px;
      padding-bottom: 30px;

      .left {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 100%;
        box-sizing: border-box;
        padding-top: 20px;
        h3 {
          color: #0ca6eb;
          margin: 0;
          font-size: 16px;
          padding-bottom: 0.5263rem;
        }
        p {
          color: #666666;
          font-size: 15px;
          line-height: 25px;
        }
      }
    }
    .zhengjibox {
      @media screen and (max-width: 540px) {
        display: none;
      }
      display: flex;
      height: 3.6842rem;
      margin-bottom: 1.0526rem;
      justify-content: center;
      align-items: center;
      .left {
        width: 8.3684rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 8.3684rem;
        box-sizing: border-box;
        padding-left: 0.8842rem;

        h3 {
          color: #0ca6eb;
          margin: 0;
          font-size: 0.3368rem;
          padding-bottom: 0.5263rem;
        }
        p {
          color: #666666;
          font-size: 0.2105rem;
          line-height: 0.4211rem;
          padding-right: 96px;
        }
      }
      .right2 {
        padding-left: 0.5263rem;
      }
    }
  }
  .youshi {
    .title {
      padding-bottom: 0.9474rem;
    }
    .contbox {
      height: 5.5368rem;
      background-color: #fbfbfb;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 540px) {
        height: 210px;
      }
      .box {
        width: 3.5579rem;
        @media screen and (max-width: 540px) {
          width: 33%;
          height: 100%;
          padding: 0 5px;
        }
        padding: 0 1rem;
        text-align: center;
        img {
          width: 0.6316rem;
          height: 0.6421rem;
          @media screen and (max-width: 540px) {
            width: 22px;
            height: 22px;
            padding-top: 50px;
          }
        }
        h3 {
          margin: 0;
          padding: 0.8105rem 0 0.4421rem 0;
          color: #0ca6eb;
          font-size: 0.2947rem;
          @media screen and (max-width: 540px) {
            font-size: 15px;
          }
        }
        p {
          color: #666666;
          line-height: 0.4211rem;
          font-size: 0.2526rem;
        }
        .p1 {
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        .p2 {
          display: none;
          width: 90%;
          margin: 0 auto;
          line-height: 20px;
          @media screen and (max-width: 540px) {
            display: block;
            font-size: 12px;
          }
        }
      }
    }
    .footertitle {
      color: #272b2d;
      font-size: 0.2526rem;
      padding: 0.8632rem 4rem 1.2316rem 4rem;
      text-align: center;
      line-height: 0.4632rem;
      @media screen and (max-width: 540px) {
        font-size: 15px;
        line-height: 25px;
      }
    }
    .tougao {
      @media screen and (max-width: 540px) {
        height: 37px;
        line-height: 37px;
        width: 100%;
        background-size: 140% 100%;
        font-size: 12px;
        background-position: 52% 0;
      }
      width: 16.6316rem;
      height: 0.7895rem;
      line-height: 0.7895rem;
      margin: 0 auto;
      margin-bottom: 0.9579rem;
      display: flex;
      justify-content: center;
      background: url("../../assets/image/Science/zhuanxiang/zhuanxiang4.webp")
        no-repeat;
      background-size: 100% 100%;
      text-align: center;
      a {
        color: #0ca7eb;
        cursor: pointer;
        background-color: #fff;
        font-size: 0.2947rem;
        display: block;
        width: 373px;
        height: 75px;
        border: 1px solid #0ca7eb;
        @media screen and (max-width: 540px) {
          width: 150px;
          height: 36px;
        }
      }
    }
  }
  .footerCard {
    height: 3.7895rem;
    width: 100%;
    background: url("../../assets/image/footer.png") no-repeat;
    background-size: 100% 100%;
    padding-left: 3rem;
    box-sizing: border-box;
    padding-top: 0.8632rem;
    @media screen and (max-width: 540px) {
      height: 220px;
      background: url("../../assets/image/footer.png") no-repeat;
      background-size: 150% 100%;
      background-position: 80% 0;
      padding-left: 40px;
      padding-top: 33px;
    }
    h3 {
      color: #ffffff;
      font-size: 0.3579rem;
      margin: 0;
      padding-bottom: 0.1053rem;
      @media screen and (max-width: 540px) {
        font-size: 19px;
      }
    }
    .span {
      display: block;
      height: 0.0632rem;
      width: 0.3158rem;
      background-color: #fff;
      margin-bottom: 0.6105rem;
      @media screen and (max-width: 540px) {
        width: 17px;
        height: 4px;
        margin-bottom: 1.8947rem;
      }
    }
    p {
      font-size: 0.2842rem;
      color: #ffffff;
      @media screen and (max-width: 540px) {
        font-size: 15px;
      }
      a {
        padding: 0 0.2105rem;
        @media screen and (max-width: 540px) {
          display: none;
        }
      }
      span {
        @media screen and (max-width: 540px) {
          display: block;
          padding-bottom: 10px;
        }
      }
    }
    .email {
      padding-top: 0.3579rem;
    }
  }
}
</style>
